// mds-dojo — dojo/dom (byId + small helpers).

export function byId(id: any, doc?: Document): any {
  if (typeof id === 'string') { return (doc || document).getElementById(id); }
  return id; // already a node (or null)
}

export function isDescendant(node: any, ancestor: any): boolean {
  let n = byId(node);
  const a = byId(ancestor);
  while (n) {
    if (n === a) { return true; }
    n = n.parentNode;
  }
  return false;
}

export function setSelectable(node: any, selectable: boolean): void {
  const n = byId(node);
  if (!n) { return; }
  n.style.userSelect = selectable ? '' : 'none';
}

const dom = { byId, isDescendant, setSelectable };
export default dom;
